import { forwardRef, type Ref, type SVGProps } from "react";
const IconFingerDrawFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M24.535 13.47 16 12.382V5a3 3 0 0 0-6 0v15s-3.72-1.73-4-1.829A3 3 0 0 0 3.2 23.4l8 6a3 3 0 0 0 1.8.6h11.7a2 2 0 0 0 1.985-1.752l1.29-10.318a4 4 0 0 0-3.44-4.46M29 10a1 1 0 0 1-.858-.483A9.97 9.97 0 0 0 20 5h-1a1 1 0 0 1 0-2h1a12.01 12.01 0 0 1 9.857 5.485A1 1 0 0 1 29 10"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFingerDrawFilledSVG);
ForwardRef.displayName = "IconFingerDrawFilled";
export { ForwardRef as IconFingerDrawFilled };
